
const config = window.__BD_CONFIG || {}
export default config
